$(document).ready(function () {
    const tabMenuContainer = $('.tab-menu-container');
    const specializedMenuWrapper = $('.hero-section .specialized-menu-wrapper');

    function centerActiveSpecializedTab(container) {
        const activeItem = container.find('.specialized-menu-item.active');
        if (activeItem.length) {
            const containerWidth = container.width();
            const itemOffset = activeItem.position().left;
            const itemWidth = activeItem.outerWidth();
            const scrollTo = itemOffset - (containerWidth / 2) + (itemWidth / 2);
            container.stop().animate({
                scrollLeft: scrollTo
            }, {
                duration: 300,
                easing: 'easeOutCubic',
                complete: function () {
                    checkScrollButtons(container);
                }
            });
        }
    }

    if (tabMenuContainer) {
        tabMenuContainer.each(function () {
            const container = $(this);
            centerActiveSpecializedTab(container);
        });
    }

    let resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            tabMenuContainer.each(function () {
                const container = $(this);
                centerActiveSpecializedTab(container);
            });
            adjustMenuItemWidths();
        }, 250);
    });

    function adjustMenuItemWidths() {
        if (!specializedMenuWrapper.length) return;
        const wrapperWidth = specializedMenuWrapper.innerWidth();
        const menuItem = specializedMenuWrapper.find('.specialized-menu-item');
        if (menuItem.length >= 1) {
            const tabMenuSection = specializedMenuWrapper.find('.tab-menu-section');
            const itemGap = parseFloat(tabMenuSection.css('gap') || 0);
            const count = menuItem.length;
            const menuItemWidth = Math.floor((wrapperWidth - (count - 1) * itemGap) / count);
            menuItem.css('width', menuItemWidth);
        }
    }

    adjustMenuItemWidths();
});